module.exports = __webpack_public_path__ + "eb12c446024694f7c27b4c0b731f89fa.svg";